import { CopyToClipboard } from '@client/new/components/copy-to-clipboard';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';

export type CreatorLinkProps = {
  url: string;
  title: string;
  urlClassName?: string;
  wrapperClassName?: string;
};
export const CreatorLink = ({
  url,
  title,
  urlClassName,
  wrapperClassName,
}: CreatorLinkProps) => (
  <div
    key={url}
    className={clsx(
      'flex px-4 py-2 justify-between bg-[#F8F8F8] rounded-md',
      wrapperClassName,
    )}
  >
    <div key={url} className="flex flex-col">
      <Typography
        variant="body"
        size="large"
        className={clsx('text-left', sprinkles({ color: 'P-80' }))}
      >
        {title}
      </Typography>
      <a href={url} target="_blank" rel="noreferrer" className="text-black">
        <Typography
          variant="body"
          size="medium"
          className={clsx(
            'max-w-[614px] text-ellipsis whitespace-nowrap overflow-hidden',
            urlClassName,
          )}
        >
          {url}
        </Typography>
      </a>
    </div>
    <CopyToClipboard
      contentToCopy={url}
      className="font-bold flex self-center"
    />
  </div>
);
